var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import './styles.scss';
function Text(_a) {
    var text = _a.text, size = _a.size, weight = _a.weight, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (_jsx("p", __assign({ className: "Text Text--" + size + " Text--" + weight + " " + className }, { children: text }), void 0));
}
export default Text;
